import MobileDeviceFull from './components/MobileDeviceFull';
import * as React from 'react';
import { mobileDeviceFullStore } from './store/store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { onSaveMobileOption } from './orchestrators/onSaveMobileOption';
import { onDiscardMobileOption } from './orchestrators/onDiscardMobileOption';
var MobileDeviceOption = {
    key: 'mobileDevice',
    titleStringKey: 'optionTitle_mobile',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_mobile',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MobileDeviceFull, null); },
        isDirty: function () {
            return mobileDeviceFullStore().isDevicesDirty ||
                mobileDeviceFullStore().isLoggingEnabledDirty ||
                mobileDeviceFullStore().isNotSendReadReceiptDirty;
        },
        onSave: onSaveMobileOption,
        onDiscard: onDiscardMobileOption,
        hideSaveDiscard: function () { return mobileDeviceFullStore().isDetailsOpen; },
    },
    isHidden: function () { return !isControlFeatureEnabled('auth-mobileDevice'); },
};
export default MobileDeviceOption;
//# sourceMappingURL=MobileDeviceOption.js.map